export const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv';
export const PDF_TYPE = 'application/pdf';
